<template>
    <div class="a-letters-index letters-index">
        <button
            v-for="(button, index) in sortedValues"
            :key="index"
            :aria-label="`${ariaLabel}${button.value}`"
            :class="{'letters-index__button--active': button === localValue}"
            :disabled="button.active"
            type="button"
            class="letters-index__button"
            @click="onCLick(button)"
        >
            {{ button }}
        </button>
    </div>
</template>

<script>
    
import { mapState } from 'vuex';

export default {
    name: 'ALettersIndex',
    props: {
        value: {
            type: String,
            default: ''
        },
        activeButtons: {
            type: Array,
            default: () => []
        },
        ariaLabel: {
            type: String,
            default: 'Letters index button'
        }
    },
    computed: {
        ...mapState({
            activeLocale: state => state.activeLocale
        }),
        localValue: {
            get() {
                return this.value;
            },
            set(e) {
                this.$emit('input', e);
            }
        },
        sortedValues() {
            const values = [...this.activeButtons];
            return values.sort((a, b) => a.localeCompare(b, 'sv'));
        }
    },
    methods: {
        onCLick(val) {
            this.localValue = val;
            this.$emit('onClick', val);
        }
    }
}
</script>

<style lang="scss">
@import "a-letters-index";
</style>